import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../services';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService implements HttpInterceptor {
  private authService!: AuthService;
  constructor(private injector: Injector) {}
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Getting token from local storage
    const dataUser = localStorage.getItem('dataUser');
    this.authService = this.injector.get(AuthService);
    // Token exist?
    if (dataUser) {
      const token = JSON.parse(dataUser).access_token;

      // Cloning token and sending it to every headers request

      if (req.url == environment.url_api + 'auth/refresh') {
        const refresh_token = JSON.parse(dataUser).refresh_token;
        req = req.clone({
          setHeaders: {
            authorization: `Bearer ${refresh_token}`,
          },
        });
      } else {
        req = req.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
          },
        });
      }
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && !req.url.includes('login')) {
          // Token is missing or invalid, log the user out
          this.authService.logout();
        }

        return throwError(error);
      })
    );
  }
}
